import { render } from "./Categoria.vue?vue&type=template&id=93e7df32"
import script from "./Categoria.vue?vue&type=script&lang=js"
export * from "./Categoria.vue?vue&type=script&lang=js"

import "./Categoria.vue?vue&type=style&index=0&id=93e7df32&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__